import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "current", "defaultCurrent", "total", "disabled", "onBlur", "onFocus", "onPageChange", "toPreviousPage", "toNextPage", "ofWord", "inputProps", "inputRef"];
// @ts-nocheck
import * as React from 'react';
import { useCallback, useRef, useImperativeHandle, useState } from 'react';
import ClassNames from 'classnames';
import { Input } from '../field';
import { KEY_VALUES, useControlled, useUpdateEffect } from '../utils';
var Pagination = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var customizePrefixCls = _ref.prefixCls,
    className = _ref.className,
    current = _ref.current,
    _ref$defaultCurrent = _ref.defaultCurrent,
    defaultCurrent = _ref$defaultCurrent === void 0 ? 1 : _ref$defaultCurrent,
    _ref$total = _ref.total,
    total = _ref$total === void 0 ? 1 : _ref$total,
    disabled = _ref.disabled,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    onPageChange = _ref.onPageChange,
    _ref$toPreviousPage = _ref.toPreviousPage,
    toPreviousPage = _ref$toPreviousPage === void 0 ? '' : _ref$toPreviousPage,
    _ref$toNextPage = _ref.toNextPage,
    toNextPage = _ref$toNextPage === void 0 ? '' : _ref$toNextPage,
    _ref$ofWord = _ref.ofWord,
    ofWord = _ref$ofWord === void 0 ? 'of' : _ref$ofWord,
    inputProps = _ref.inputProps,
    inputRefProp = _ref.inputRef,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var MIN = 0;
  var prefixCls = customizePrefixCls ? customizePrefixCls + "-pagination" : 'ap-pagination';
  var classNames = ClassNames(prefixCls, className);
  var _useControlled = useControlled(current, defaultCurrent),
    currentPage = _useControlled[0],
    setCurrentPage = _useControlled[1],
    isControlled = _useControlled[2];
  var _useState = useState(currentPage),
    inputValue = _useState[0],
    setInputValue = _useState[1];
  var inputRef = useRef(null);
  var checkValue = function checkValue(value, min, max) {
    if (typeof value === 'undefined') {
      return value;
    }
    if (value < min) {
      return min;
    }
    if (value > max) {
      return max;
    }
    return value;
  };
  useImperativeHandle(ref, function () {
    return {
      setPageNumber: function setPageNumber(page) {
        var newPage = checkValue(page, MIN, total);
        setCurrentPage(newPage);
        setInputValue(newPage);
      },
      getElement: function getElement() {
        return ref.current;
      }
    };
  });
  useUpdateEffect(function () {
    if (total === 0) {
      setInputValue(0);
    }
  }, [total]);
  useUpdateEffect(function () {
    isControlled && setInputValue(current);
  }, [current, isControlled]);
  var prev = function prev(event) {
    var current = Math.max(Number(currentPage) - 1, 1);
    if (current < 1) {
      return;
    }
    setInputValue(current);
    setCurrentPage(current);
    onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(current);
  };
  var next = useCallback(function (event) {
    var current = Math.min(Number(currentPage) + 1, total);
    if (current > total) {
      return;
    }
    setInputValue(current);
    setCurrentPage(current);
    onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(current);
  }, [currentPage, total]);
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === KEY_VALUES.ENTER) {
      var _event$target;
      if (!(event.target instanceof HTMLDivElement)) {
        return;
      }
      var _event$target$dataset = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target['dataset'],
        key = _event$target$dataset.key;
      if (key === 'previous') {
        prev(event);
      } else {
        next(event);
      }
    }
  };
  var getSafeValue = useCallback(function (e) {
    var inputValue = e.target.value;
    var value;
    if (inputValue === '') {
      value = inputValue;
    } else if (isNaN(Number(inputValue))) {
      value = currentPage;
    } else if (inputValue > total) {
      value = total;
    } else {
      value = Number(inputValue);
    }
    return value;
  }, [total, MIN]);
  var handleInputBlur = useCallback(function (event) {
    var value = getSafeValue(event);
    if (value !== currentPage) {
      setCurrentPage(value);
      onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(value);
    }
  }, [onPageChange, total, setCurrentPage, currentPage]);
  var handleInputKeyDown = function handleInputKeyDown(e) {
    if (e.key === KEY_VALUES.UP || e.key === KEY_VALUES.DOWN) {
      e.preventDefault();
    }
  };
  var handleChange = function handleChange(page) {
    if (page > total || page < 1) {
      return;
    }
    if (page !== currentPage) {
      setCurrentPage(page);
      onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(page);
      setInputValue(page);
    }
  };
  var handleKeyUp = function handleKeyUp(e) {
    var value = getSafeValue(e);
    if (inputValue !== value) {
      setInputValue(value);
    }
    // @ts-ignore
    if (e.key === KEY_VALUES.ENTER) {
      handleChange(value);
      // @ts-ignore
    } else if (e.key === KEY_VALUES.UP) {
      handleChange(value + 1);
      // @ts-ignore
    } else if (e.key === KEY_VALUES.DOWN) {
      handleChange(value - 1);
    }
  };
  var renderPrev = function renderPrev() {
    var disabled = currentPage <= 1;
    return /*#__PURE__*/React.createElement("div", {
      role: "button",
      "aria-label": "previous",
      "aria-disabled": disabled,
      "data-key": "previous",
      className: ClassNames(prefixCls + "-btn-prev", disabled && 'disabled', toPreviousPage && 'large'),
      tabIndex: disabled ? undefined : 0,
      onClick: disabled ? function () {} : prev,
      onKeyDown: disabled ? function () {} : handleKeyDown
    }, /*#__PURE__*/React.createElement("span", {
      className: "Appkit4-icon icon-left-chevron-outline"
    }), toPreviousPage && /*#__PURE__*/React.createElement("span", {
      className: prefixCls + "-btn-text"
    }, toPreviousPage));
  };
  var renderNext = function renderNext() {
    var disabled = currentPage >= total;
    return /*#__PURE__*/React.createElement("div", {
      role: "button",
      "aria-label": "next",
      "aria-disabled": disabled,
      className: ClassNames(prefixCls + "-btn-next", disabled && 'disabled', toNextPage && 'large'),
      tabIndex: disabled ? undefined : 0,
      "data-key": "next",
      onClick: disabled ? function () {} : next,
      onKeyDown: disabled ? function () {} : handleKeyDown
    }, toNextPage && /*#__PURE__*/React.createElement("span", {
      className: prefixCls + "-btn-text"
    }, toNextPage), /*#__PURE__*/React.createElement("span", {
      className: "Appkit4-icon icon-right-chevron-outline"
    }));
  };
  var handleInputFocus = function handleInputFocus(event) {
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames,
    ref: ref
  }, props), renderPrev(), /*#__PURE__*/React.createElement("label", {
    className: prefixCls + "-field"
  }, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    ref: inputRef,
    hideTitleOnInput: true,
    value: String(inputValue),
    onBlur: handleInputBlur,
    onChange: function onChange(v, e) {
      return handleKeyUp(e);
    },
    onFocus: handleInputFocus,
    onKeyDown: handleInputKeyDown,
    onKeyUp: handleKeyUp,
    disabled: disabled,
    inputProps: _extends({
      'aria-label': String(inputValue)
    }, inputProps)
  }), /*#__PURE__*/React.createElement("span", {
    className: prefixCls + "-total"
  }, /*#__PURE__*/React.createElement("span", null, ofWord), /*#__PURE__*/React.createElement("span", null, total))), renderNext());
});
Pagination.displayName = 'Pagination';
export default Pagination;